import { bridge } from '@sloyd/viewer';
import { useEffect } from 'react';
import {
  changeGenerator,
  loadGenerator,
  prepareTour,
  runTourSingle,
  stopTour,
} from '../utils/tour';

export function useTour(
  instanceId: string,
  generator: IGenerator,
  palettes: IPalettes,
  isLoaded: boolean
) {
  useEffect(() => {
    if (!isLoaded) return;

    prepareTour(palettes, 2000, 20);

    if (!generator) {
      bridge.clear(instanceId);
      stopTour();
      return;
    }

    changeGenerator(generator);
    runTourSingle(instanceId);

    return () => {
      stopTour();
    };
  }, [isLoaded]);

  useEffect(() => {
    changeGenerator(generator);
    loadGenerator(instanceId);
  }, [generator]);
}
